import React, { useCallback, useEffect, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { ContentLoader, MainWr, applicationStore } from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';

import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import GameWebMobileContainer from './containers/gameWebMobileContainer';

import { RoutePaths } from './enums/routes';

import { Factory } from './core';
import { gameLiveConnection, gameService } from './services';
import { FakeRenderImages } from './components/fakeRenderImages';

const App = observer(() => {
  const { reconnect } = popupStore;
  const components = useMemo(
    () => [
      {
        path: RoutePaths.game,
        element: <GameWebMobileContainer />,
        defaultRedirectComponent: true,
      },
      {
        path: RoutePaths.replay,
        element: <GameWebMobileContainer />,
      },
    ],
    []
  );

  useEffect(() => {
    applicationStore.setIsBogLine(true, true);
    const intervalId = setInterval(() => gameLiveConnection.sendPing(), 3000);
    return () => {
      intervalId && clearInterval(intervalId);
    };
  }, []);

  const lostInternetConnection = useCallback(() => {
    popupStore.open({ name: PopUps.ConnectionError });
    popupStore.onConnectionError(true);
  }, []);

  const reconnectInternet = useCallback(() => {
    gameService.socketRecursiveReconnecting();
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  // useEffect(() => {
  //   document
  //     .getElementById('root')
  //     .classList.add(isMobile() ? 'halloween-mode-mobile' : 'halloween-mode-web');
  // }, [])

  return (
    <BrowserRouter>
      {reconnect && <ContentLoader isFull />}
      <MainWr>
        <Factory components={components} />
        <FakeRenderImages />
      </MainWr>
    </BrowserRouter>
  );
});

export default App;
